
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partner/[publisherSlug]",
      function () {
        return require("private-next-pages/partner/[publisherSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partner/[publisherSlug]"])
      });
    }
  